<p-toast></p-toast>
<div *ngIf="applicationDetails?.APP_ID">
  <div class="col-12">
    <div class="card form-heading" reflow="true">
      <h5>{{'FARMER_APPLICATION_DETAILS' | translate}}</h5>
    </div>
    <div class="card hidden-xs to-print" id="printableArea" reflow="true">
      <div class="consent-form border">
        <!-- <div [align]="'right'" class="print border bold" style="margin-top: 0px ;" >Print Form</div> -->
        <div class="header border">
          <div class="col-3">
            {{'REG_DATE' | translate}} : {{ applicationDetails?.RegDate | date: "mediumDate" }}
          </div>
          <div class="col-6">
            <h6>{{'FARMER_APPLICATION_FORM_FOR_MICRO_IRRIGATION_SCHEME' | translate}}</h6>
          </div>
          <div class="col-3">
            <p *ngIf="applicationDetails?.FarmerPersonalData?.Farmer_Photo">
              <a style="cursor: pointer" [href]="applicationDetails?.FarmerPersonalData?.Farmer_Photo"
                target="_blank">{{'VIEW_IMAGE' | translate}}</a>
            </p>
            <!-- <p-image *ngIf="applicationDetails?.FarmerPersonalData?.Farmer_Photo"
              [src]="applicationDetails?.FarmerPersonalData?.Farmer_Photo" alt="Image" width="100" class="ml-2"
              height="50px" iconPos="left"></p-image> -->
          </div>
        </div>
        <div class="sub-header">
          <table class="border">
            <tr>
              <td>
                <p class="head">{{'APPLICATION_NO' | translate}}</p>
                <p class="bold">{{ applicationDetails.APP_ID }}</p>
              </td>
              <td>
                <p class="head">{{'FINANCIAL_YEAR' | translate}}</p>
                <p class="bold">{{ applicationDetails?.FincialYear }}</p>
              </td>
              <td>
                <p class="head">{{'SCHEME_NAME' | translate}}</p>
                <p class="bold">
                  {{ applicationDetails.Scheme_Code }}
                </p>
              </td>
            </tr>
          </table>
        </div>

        <!-- personal details start -->
        <ng-container *ngIf="applicationDetails.FarmerPersonalData">
          <div class="print border bold">{{'PERSONAL_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <td>
                  <p class="bold">{{'FARMER_NAME' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Name }}</p>
                </td>
                <td>
                  <p class="bold">{{'FATHER_NAME' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Father_name }}</p>
                </td>
                <td>
                  <p class="bold">{{'MOTHER_NAME' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Mother_Name }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="bold">{{'SEX' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Gender }}</p>
                </td>
                <td>
                  <p class="bold">{{'DATE_OF_BIRTH' | translate}}</p>
                  <p>
                    {{
                    applicationDetails.FarmerPersonalData.DOB
                    | date: "mediumDate"
                    }}
                  </p>
                </td>
                <td>
                  <p class="bold">{{'MOBILE' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Mobile }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="bold">{{'EMAIL' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Email_ID }}</p>
                </td>
                <td>
                  <p class="bold">{{'VILLAGE' | translate}}</p>
                  <p>
                    {{ applicationDetails.FarmerPersonalData.Village_Code }}
                  </p>
                </td>
                <td>
                  <p class="bold">{{'BLOCK' | translate}}</p>
                  <p>
                    {{ applicationDetails.FarmerPersonalData.Block }}
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="bold">{{'DISTRICT' | translate}}</p>
                  <p>
                    {{ applicationDetails.FarmerPersonalData.District }}
                  </p>
                </td>
                <td>
                  <p class="bold">{{'CASTE' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Caste_Code }}</p>
                </td>
                <td>
                  <p class="bold">{{'ADDRESS' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Address }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="bold">{{'PINCODE' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Pin_Code }}</p>
                </td>
                <td>
                  <p class="bold">{{'MFMB_NO' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.MFMBNo }}</p>
                </td>
                <td>
                  <p class="bold">{{'APPLICATION_TYPE' | translate}}</p>
                  <p>{{ applicationDetails?.AppType }}</p>
                </td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- personal details end -->


        <!-- member details -->
        <ng-container *ngIf="
            applicationDetails.Group_Datas &&
            applicationDetails.Group_Datas.length > 0
          ">
          <div class="print border bold">{{'MEMBER_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'MEMBER_NO' | translate}}</th>
                <th>{{'NAME' | translate}}</th>
                <th>{{'FATHER_NAME' | translate}}</th>
                <th>{{'MOTHER_NAME' | translate}}</th>
                <th>{{'GENDER' | translate}}</th>
                <th>{{'DATE_OF_BIRTH' | translate}}</th>
                <th>{{'CASTE' | translate}}</th>
                <th>{{'ADDRESS' | translate}}</th>
                <th>{{'PPP_ID' | translate}}</th>
                <th>{{'ID_PROOF_FILE_PATH' | translate}}</th>
                <th>{{'AADHAR_COPY' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.Group_Datas">
                <td>{{ item.memberID }}</td>
                <td>{{ item.Name }}</td>
                <td>{{ item.Father_name }}</td>
                <td>{{ item.Mother_Name }}</td>
                <td>{{ item.Gender }}</td>
                <td>{{ item.DOB }}</td>
                <td>{{ item.Caste_Code }}</td>
                <td>{{ item.Address }}</td>
                <td>{{ item.PPP_ID }}</td>
                <td><a [href]="item?.ID_Proof_FilePath" target="_blank">{{'VIEW_ID_PROOF' | translate}}</a></td>
                <td><a [href]="item?.Aadhaar_Copy_Upload" target="_blank">{{'VIEW_Aadhar_Copy' | translate}}</a></td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- member details end -->

        <!-- land details -->
        <ng-container *ngIf="
            applicationDetails.FarmerLand &&
            applicationDetails.FarmerLand.length > 0
          ">
          <div class="print border bold">{{'LAND_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'MEMBER_ID' | translate}}</th>
                <th>{{'TOTAL_AREA' | translate}}</th>
                <th>{{'MORABBA_NO' | translate}}</th>
                <th>{{'KILLA_NO' | translate}}</th>
                <th>{{'CROP_TYPE' | translate}}</th>
                <th>{{'VILLAGE' | translate}}</th>
                <th>{{'LAND_DOC' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.FarmerLand">
                <td>{{ item?.memberID }}</td>
                <td>{{ item?.totalArea }}</td>
                <td>{{ item?.morabbaNo }}</td>
                <td>{{ item?.killaNo }}</td>
                <td>{{ item?.cropType }}</td>
                <td>{{ item?.Village }}</td>
                <td>
                  <div class="hidden-print">
                    <a style="cursor: pointer" [href]="item?.landPath" target="_blank">{{'VIEW_LAND_DOC' |
                      translate}}</a>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{'GRAND_TOTAL_AREA' | translate}}</th>
                <th>{{totalLandArea | number : '1.2-2'}}</th>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- land details end -->

        <!-- existing-mi-details -->
        <ng-container *ngIf=" existingMIDetails && existingMIDetails.length > 0 ">
          <div class="print border bold">{{'EXISTING_MI_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'PROGRAM_NAME' | translate}}</th>
                <th>{{'MORABBA_NO' | translate}}</th>
                <th>{{'KILLA_NO' | translate}}</th>
                <th>{{'TOTAL_AREA' | translate}}</th>
                <th>{{'IS_SUBSIDY_AVAIL' | translate}}</th>
                <th>{{'YEAR' | translate}}</th>
              </tr>
              <tr *ngFor="let item of existingMIDetails">
                <td>{{ item?.ProgrammeName }}</td>
                <td>{{ item?.Morabba_No }}</td>
                <td>{{ item?.Killa_No }}</td>
                <td>{{ item?.TotalArea }}</td>
                <td>{{ item?.Is_Subsidy_Avail }}</td>
                <td>{{ item?.Year_subsidy }}</td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- existing-mi-details-ends -->

        <!-- On-Farm tank details -->
        <ng-container *ngIf="
            applicationDetails.OnFarm_Pond_Datas &&
            applicationDetails.OnFarm_Pond_Datas.length > 0
          ">
          <div class="print border bold">{{'ON_FARM_POND_TANK_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'MORABBA_NO' | translate}}</th>
                <th>{{'KILLA_NO' | translate}}</th>
                <th>{{'LATITUDE' | translate}}</th>
                <th>{{'LONGITUDE' | translate}}</th>
                <th>{{'TOP_SIZE' | translate}}</th>
                <th>{{'BOTTOM_SIZE' | translate}}</th>
                <th>{{'DEPTH' | translate}}</th>
                <th>{{'WATER_CAPACITY' | translate}}</th>
                <th>{{'TOTAL_COST' | translate}}</th>
                <th>{{'SCAN_COPY' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.OnFarm_Pond_Datas">
                <td>{{ item.morabbaNo }}</td>
                <td>{{ item.killaNo }}</td>
                <td>{{ item.latitude }}</td>
                <td>{{ item.longitude }}</td>
                <td>{{ item.topSize }}</td>
                <td>{{ item.bottomSize }}</td>
                <td>{{ item.dept }}</td>
                <td>{{ item.waterCapacity }}</td>
                <td>{{ item.totalCost }}</td>
                <td *ngIf="applicationDetails.ConsentPath.length">
                  <a style="cursor: pointer" [href]="applicationDetails?.ConsentPath"
                    target="_blank">{{'VIEW_SIGNATURED_COLLECTIVE_DECLARATION' | translate}}</a>
                </td>
                <td *ngIf="!applicationDetails.ConsentPath.length">{{'EMPTY' | translate}}</td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- On-Farm tank details end -->

        <!-- On-Farm solar pump -->
        <ng-container *ngIf="
            applicationDetails.Solar_Pump_Datas &&
            applicationDetails.Solar_Pump_Datas.length > 0
          ">
          <div class="print border bold">{{'ON_FARM_SOLAR_PUMP' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'CONTROLLER_TYPE' | translate}}</th>
                <th>{{'PUMP_CATEGORY' | translate}}</th>
                <th>{{'TYPE' | translate}}</th>
                <th>{{'PUMP_CAPACITY' | translate}}</th>
                <th>{{'FARMER_SHARE' | translate}}</th>
                <th>{{'PRIMARY_VENDOR' | translate}}</th>
                <th>{{'SECONDARY_VENDOR' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.Solar_Pump_Datas">
                <td>{{ item.controlerType }}</td>
                <td>{{ item.pumpCategory }}</td>
                <td>{{ item.type }}</td>
                <td>{{ item.pumpCapacity }}</td>
                <td>{{ item.farmerShare }}</td>
                <td>{{ item.primaryVendor }}</td>
                <td>{{ item.secondaryVendor }}</td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- On-Farm solar pump end -->

        <!-- MI Details -->
        <ng-container *ngIf="
            applicationDetails.New_MI_Datas &&
            applicationDetails.New_MI_Datas.length > 0
          ">
          <div class="print border bold">
            {{'ON_FARMER_MI_COMPONENTS_AND_VENDOR_DETAILS' | translate}}
          </div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'PROGRAMME_NAME' | translate}}</th>
                <th>{{'LAND_DATA' | translate}}</th>
                <th>{{'VENDOR_NAME' | translate}}</th>
                <th>{{'TOTAL_AREA' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.New_MI_Datas">
                <td>{{ item.programName }}</td>
                <td>{{ item.landData }}</td>
                <td>{{ item.miVendorName }}</td>
                <td>{{ item.totalArea }}</td>
              </tr>
            </table>

            <div class="border flex justify-content-end">
              <p class="mx-3">
                <b>{{'GRAND_TOTAL_AREA' | translate}}: {{ totalArea | number: "1.2-2" }} </b>
              </p>
            </div>
          </div>
        </ng-container>
        <!-- MI Details end -->

        <!-- water course data start -->
        <ng-container *ngIf="
            applicationDetails.Water_Course_Datas &&
            applicationDetails.Water_Course_Datas.length > 0
          ">
          <div class="print border bold">{{'WATER_COURSE_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'CANAL' | translate}}</th>
                <th>{{'OUTLET' | translate}}</th>
                <th>{{'WORK_TYPE' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.Water_Course_Datas">
                <td>{{ item?.Canal_Outlet_Name }}</td>
                <td>{{ item?.RD }}</td>
                <td>{{ item?.WorkTypeName }}</td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- water course data end -->
      </div>

      <!-- pre-estimate-survey -->
      <div class="pre-estimate-form border my-4" *ngIf="preEstimationDataArray.length > 0">
        <div class="mt-2 form-name">
          <h5> {{'PRE_ESTIMATE_SURVEY' | translate}} </h5>
        </div>

        <div class="consent-form" *ngFor="let preEstimateDetails of preEstimationDataArray">
          <ng-container>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'APP_ID' | translate}}</p>
                    <p>{{ preEstimateDetails?.AppID }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'PROGRAMME_NAME' | translate}}</p>
                    <p>{{ preEstimateDetails?.ProgramName }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'SOIL_TYPE' | translate}}</p>
                    <p>{{ preEstimateDetails?.SoilType }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'CROP_TYPE' | translate}}</p>
                    <p>
                      {{ preEstimateDetails?.selectedCropType }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'CROP_NAME' | translate}}</p>
                    <p>
                      {{ preEstimateDetails?.selectedCrop }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'WATER_SOURCE' | translate}}</p>
                    <p>{{ preEstimateDetails?.WaterSource }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'WATER_PRESSURE' | translate}}</p>
                    <p>{{ preEstimateDetails?.WaterPressure }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'WATER_QUALITY' | translate}}</p>
                    <p>{{ preEstimateDetails?.WaterQuality }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'WATER_REQ' | translate}}</p>
                    <p>{{ preEstimateDetails?.WaterQuantity }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'PH' | translate}}</p>
                    <p>{{ preEstimateDetails?.PH }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'EC' | translate}}</p>
                    <p>{{ preEstimateDetails?.EC }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'DATE_OF_SURVEY' | translate}}</p>
                    <p>{{ preEstimateDetails?.DateOfSurvey }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                    <p>{{ preEstimateDetails?.PlantSpacing }}</p>
                  </td>

                  <td>
                    <p class="bold">{{'ROW_SPACING' | translate}}</p>
                    <p>{{ preEstimateDetails?.RowSpacing }}</p>
                  </td>
                </tr>
              </table>
              <div class="print border bold">
                {{'LIST_GPS_COORDINATES' | translate}}
              </div>
              <div class="table">
                <table class="border">
                  <tr>
                    <th>{{'CORNER_ID' | translate}}</th>
                    <th>{{'LATITUDE' | translate}}</th>
                    <th>{{'LONGITUDE' | translate}}</th>
                  </tr>
                  <tr *ngFor="let item of preEstimateDetails.listGPSCoordinates">
                    <td>{{item.CornerID}}</td>
                    <td>{{item.Latitude}}</td>
                    <td>{{item.Longitude}}</td>
                  </tr>
                </table>
              </div>
              <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapPreEstimate">
                <div class="field col-12 md:col-12">
                  <p-gmap [options]="preEstimateDetails?.optionsPreEstimate" type="satellite"
                    [overlays]="preEstimateDetails?.overlaysPreEstimate"
                    [style]="{'width':'100%','height':'320px'}"></p-gmap>
                </div>
              </div>
              <div class="print border bold">
                {{'LIST_IMAGE_PATH' | translate}}
              </div>
              <div class="table">
                <table class="border">
                  <tr>
                    <th>{{'IMAGE_PATH' | translate}}</th>
                    <th>{{'DOCUMENT_TYPE' | translate}}</th>
                  </tr>
                  <tr *ngFor="let item of preEstimateDetails.listImagePath">
                    <td><a style="cursor: pointer" [href]="item.ImagePath" target="_blank">{{'VIEW_IMAGE' |
                        translate}}</a></td>
                    <td>{{item.DocumentType}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </ng-container>

        </div>
      </div>
      <!-- pre-estimate-survey end-->


      <!-- MI-Estimation -->
      <div class="mi-estimate-form border my-4" *ngIf="miEstimationDataArray.length > 0">
        <div class="mt-2 form-name">
          <h5> {{'MI_ESTIMATION' | translate}} </h5>
        </div>

        <div class="consent-form" *ngFor="let vendorApplicationDetails of miEstimationDataArray">
          <ng-container>
            <div class="sub-header">
              <table class="border">
                <tr>
                  <td>
                    <p class="head">{{'APPLICATION_NO' | translate}}</p>
                    <p class="bold appId">{{
                      vendorApplicationDetails?.AppID
                      }}</p>
                  </td>
                  <td>
                    <p class="head">{{'VENDOR_NAME' | translate}}</p>
                    <p class="bold">{{ vendorApplicationDetails?.VendorName }}</p>
                  </td>
                  <td>
                    <p class="head">{{'PROGRAMME_NAME' | translate}}</p>
                    <p class="bold">
                      {{ vendorApplicationDetails?.ProgrammeName }}
                    </p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>
          <!-- personal details start -->
          <ng-container>
            <div class="print border bold">{{'ESTIMATION_DETAILS' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'FARMER_SHARE_AMOUNT' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.FarmerShareAmount }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'COMPONENT_AMOUNT' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.ComponentAmount }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TAX_RATE' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.TaxRate }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'DISCOUNT_RATE' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.DiscountRate }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'OTHER_TRANSPORT_EXPENSES' | translate}}</p>
                    <p>
                      {{ vendorApplicationDetails?.TransportOtherExpenses }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'MAX_SUBSIDY_AMOUNT' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.MaxSubSidyAmount }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'MIAREA' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.MIArea }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'LAND_MAP_PATH' | translate}}</p>
                    <p>
                      <a href="{{ vendorApplicationDetails?.LandMapPath }}" target="_blank">open path</a>
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'SIGNATURE' | translate}}</p>
                    <p>
                      <a href="{{ vendorApplicationDetails?.SignaturePath }}" target="_blank">open path</a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'CROP_TYPE' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.selectedCropType }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'CROP_NAME' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.selectedCrop }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.PlantSpacing }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'ROW_SPACING' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.RowSpacing }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'REMARKS' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.Remarks }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>

          <!-- member details -->
          <ng-container *ngIf="
              vendorApplicationDetails?.EstimationComponentDetail &&
              vendorApplicationDetails?.EstimationComponentDetail.length > 0
            ">
            <div class="print border bold">{{'ESTIMATIONS_COMPONENT_DETAIL' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <th>{{'CAT_ID' | translate}}</th>
                  <th>{{'CAT_NAME' | translate}}</th>
                  <th>{{'COMPONENT_ID' | translate}}</th>
                  <th>{{'COMPONENT_NAME' | translate}}</th>
                  <th>{{'SIZE_ID' | translate}}</th>
                  <th>{{'SIZE' | translate}}</th>
                  <th>{{'PRICE' | translate}}</th>
                  <th>{{'QUANTITY' | translate}}</th>
                  <th>{{'TOTAL_COST' | translate}}</th>
                  <!-- <th>GST</th> -->
                </tr>
                <tr *ngFor="let item of vendorApplicationDetails?.EstimationComponentDetail">
                  <td>{{ item.CatID }}</td>
                  <td>{{ item.CatName }}</td>
                  <td>{{ item.ComponentID }}</td>
                  <td>{{ item.ComponentName }}</td>
                  <td>{{ item.SizeID }}</td>
                  <td>{{ item.Size }}</td>
                  <td>{{ item.Price }}</td>
                  <td>{{ item.Quantity }}</td>
                  <td>{{ item.Price*item.Quantity | number: "1.2-2" }}</td>
                  <!-- <td>{{item.GST}}</td> -->
                </tr>
              </table>
              <div class="border flex justify-content-end">
                <p class="mx-3">
                  <b>{{'COMPONENT_TOTAL' | translate}}: {{
                    vendorApplicationDetails?.ComponentAmount/(1-vendorApplicationDetails?.DiscountRate/100) | number:
                    "1.2-2" }} </b>
                </p>
              </div>
            </div>
          </ng-container>
          <!-- member details end -->
        </div>
      </div>
      <!-- MI-Estimation-end -->


      <!-- Sanction-letter-start -->
      <div class="sanction-letter-form border my-4" *ngIf="sanctionLetterDataArray.length > 0">
        <div class="mt-2 form-name">
          <h5> {{'SANCTION_LETTER' | translate}} </h5>
        </div>

        <div class="consent-form" *ngFor="let sanctionLetterData of sanctionLetterDataArray">
          <div class="card">
            <ng-container>
              <div class="print border bold" style="margin-top: 1px; text-align: center">
                <div class="flex justify-content-center">
                  <img src="assets/micada_logo.png" alt="footer sections" width="100" height="40" class="mr-2 mt-1" />
                </div>
                <div class="mt-3 headings">
                  <strong> {{'SANCTION_LETTER' | translate}} </strong>
                  <br />
                  <strong> {{'HARYANA' | translate}} </strong><br />
                  <strong> {{'FINANCIAL_YEAR_2022_2023' | translate}} </strong>
                </div>
              </div>

              <div class="header_sanction my-3 mx-2">
                {{'BASED_ON_DOCUMENTS' | translate}} <b>{{ sanctionLetterData?.FarmerName }}</b> {{'SON_OF' |
                translate}}
                {{ sanctionLetterData?.FatherName }} {{'VILLAGE' | translate}}
                {{ sanctionLetterData?.Village }} {{'DISTRICT' | translate}}
                {{ sanctionLetterData?.District }} {{'SANCTION_MSG' | translate}}:-
              </div>

              <div class="consent-form">
                <div class="table">
                  <table>
                    <tr>
                      <td>
                        <p class="bold">{{'APPLICATION_ID' | translate}}</p>
                        <p>{{ sanctionLetterData?.AppID }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'AREA_IN' | translate}}</p>
                        <p>{{ sanctionLetterData?.Area }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'KHASRA_NO_OR_KILLA_NO' | translate}}</p>
                        <p>{{ sanctionLetterData?.KhasraAndKillaNo }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="bold">{{'CROP' | translate}}</p>
                        <p>{{ sanctionLetterData?.CropName }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'SPACING_MTS' | translate}}</p>
                        <p>{{ sanctionLetterData?.Spacing }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'TYPE_OF_MIS' | translate}}</p>
                        <p>{{ sanctionLetterData?.TypeOfMIS }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="bold">*{{'ESTIMATED_COST_OF_SYSTEMS' | translate}}</p>
                        <p>{{ sanctionLetterData?.EstimatedCost }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'ESTIMATED_FARMER_SHARE' | translate}}</p>
                        <p>{{ sanctionLetterData?.EstimatedFarmerShare }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'SUBSIDY_SHARE_AS_PER_SCHEME' | translate}}</p>
                        <p>{{ sanctionLetterData?.SubsidyShare }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="bold">{{'FARMER_TYPE' | translate}}</p>
                        <p>{{ sanctionLetterData?.FarmerType }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'CATEGORY' | translate}}</p>
                        <p>{{ sanctionLetterData?.Category }}</p>
                      </td>
                    </tr>
                  </table>
                  <p class="bold mt-2">
                    {{'AMOUNT_OF_FARMER_SHARE' | translate}}:
                    {{ sanctionLetterData?.EstimatedFarmerShare }}
                  </p>
                </div>
              </div>

              <div class="details mt-3">
                <div class="flex justify-content-center bold mb-1">
                  {{'BANK_ACCOUNT_DETAILS' | translate}}
                </div>

                <div class="information">
                  <p>
                    {{'NAME_OF_FARMER_AS_IN_BANK_ACCOUNT' | translate}}:
                    {{ sanctionLetterData?.NameOfFarmerAsOnBankAcc }}
                  </p>
                  <p>{{'NAME_OF_BANK' | translate}}: {{ sanctionLetterData?.NameOfBank }}</p>
                  <p>{{'IFSC_CODE' | translate}}: {{ sanctionLetterData?.IFSCCode }}</p>
                  <p>{{'ACCOUNT_NO'| translate}}.: {{ sanctionLetterData?.AccountNo }}</p>
                  <p>{{'BRANCH_NAME' | translate}}: {{ sanctionLetterData?.BranchName }}</p>
                </div>

                <div class="letter mt-3">
                  <p>{{'TO' | translate}}</p>
                  <div class="mx-3">
                    <p>
                      {{'SRI_SMT' | translate}}, <b>{{ sanctionLetterData?.FarmerName }}</b> S/o
                      <b>{{ sanctionLetterData?.FatherName }}</b> Vill.
                      <b>{{ sanctionLetterData?.Village }}</b> District
                      <b>{{ sanctionLetterData?.District }}</b>
                    </p>
                    <p>{{'REGISTERED_MANUFACTURER' | translate}} <b>{{ sanctionLetterData?.VendorName }}</b></p>
                    <p>{{'DISTRICT_OFFICER_INCHARGE_OF_MI' | translate}} <b>{{ sanctionLetterData?.XENName }}</b> <b>(XEN {{ sanctionLetterData?.XENDistrict }})</b></p>
                  </div>
                </div>
              </div>
              <div class="note mt-5">
                <p>
                  *{{'NOTE' | translate}}: {{"AMOUNT_OF_ASSISTANCE_PHYSICAL_VERIFICATION" | translate}}.<br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {{'APPROVED_MAX_ASSISTANCE' | translate}}.
                </p>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- Sanction-letter-end -->


      <!-- MI-BOQ -->
      <div class="mi-boq-form border my-4" *ngIf="miBOQDataArray.length > 0">
        <div class="mt-2 form-name">
          <h5> {{'MI_BOQ' | translate}} </h5>
        </div>
        <div class="consent-form" *ngFor="let appDetails of miBOQDataArray">
          <ng-container>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'FARMER_SHARE_AMOUNT' | translate}}</p>
                    <p>{{ appDetails?.FarmerShareAmount }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'BILLED_COMPONENT_AMOUNT' | translate}}</p>
                    <p>{{ appDetails?.ComponentAmount }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'BILL_COPY' | translate}}</p>
                    <p>
                      <a href="{{ appDetails?.BillCopyPath }}" target="_blank">{{'VIEW' | translate}}</a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'TAX_RATE' | translate}}</p>
                    <p>{{ appDetails?.TaxRate }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'DISCOUNT_RATE' | translate}}</p>
                    <p>{{ appDetails?.DiscountRate }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'OTHER_TRANSPORT_EXPENSES' | translate}}</p>
                    <p>{{ appDetails?.BilledTransportAmount }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'MAX_SUBSIDY_AMOUNT' | translate}}</p>
                    <p>{{ appDetails?.MaxSubSidyAmount }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'MIAREA' | translate}}</p>
                    <p>{{ appDetails?.MIArea }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'LAND_MAP_PATH' | translate}}</p>
                    <p>
                      <a href="{{ appDetails?.LandMapPath }}" target="_blank">{{'OPEN_PATH' | translate}}</a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                    <p>{{ appDetails?.PlantSpacing }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'ROW_SPACING' | translate}}</p>
                    <p>{{ appDetails?.RowSpacing }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'REMARKS' | translate}}</p>
                    <p>{{ appDetails?.Remarks }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>

          <!-- member details -->
          <ng-container *ngIf="
              appDetails?.EstimationComponentDetail &&
              appDetails?.EstimationComponentDetail.length > 0
            ">
            <div class="print border bold">{{'BOQ_COMPONENT_DETAIL' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <th>{{'CAT_ID' | translate}}</th>
                  <th>{{'CAT_NAME' | translate}}</th>
                  <th>{{'COMPONENT_ID' | translate}}</th>
                  <th>{{'COMPONENT_NAME' | translate}}</th>
                  <th>{{'SIZE_ID' | translate}}</th>
                  <th>{{'SIZE' | translate}}</th>
                  <th>{{'PRICE' | translate}}</th>
                  <th>{{'QUANTITY' | translate}}</th>
                  <th>{{'TOTAL_COST' | translate}}</th>
                  <!-- <th>GST</th> -->
                </tr>
                <ng-container *ngFor="let item of appDetails?.EstimationComponentDetail">
                <tr >
                  <td>{{ item.CatID }}</td>
                  <td>{{ item.CatName }}</td>
                  <td>{{ item.ComponentID }}</td>
                  <td>{{ item.ComponentName }}</td>
                  <td>{{ item.SizeID }}</td>
                  <td>{{ item.Size }}</td>
                  <td>{{ item.Price }}</td>
                  <td>{{ item.Quantity }}</td>
                  <td>{{ item.Price*item.Quantity }}</td>
                </tr>
                <tr *ngIf="item?.inventory && item?.inventory?.length > 0" >
                  <td colspan="12">
                    <div class="print border bold">{{item.ComponentName}} - Inventory
                    <div class="table">
                  <table class="border">
                      <tr>
                          <th>Lot No</th>
                          <th>Batch No</th>
                          <!-- <th>Quantity</th> -->
                          <th>Quantity Used</th>
                          <th>Remaining Quantity</th>                              
                      </tr >
                          <tr *ngFor="let rowdata of item?.inventory">
                              <td >{{rowdata.lotNo}}</td>
                              <td >{{rowdata.batchNumber}}</td>

                              <!-- <td>{{rowdata.Quantity}}</td> -->
                              <td>{{rowdata.QuantityUsed}}</td>
                              <td>{{rowdata.remainingQuantity}}</td>
                          </tr>
                  </table>
                </div> </div>
                </td>
                </tr>
            </ng-container>
              </table>
              <div class="border flex justify-content-end">
                <p class="mx-3">
                  <b>{{'COMPONENT_TOTAL' | translate}}: {{ appDetails?.ComponentAmount/(1-appDetails?.DiscountRate/100)
                    | number: "1.2-2" }} </b>
                </p>
              </div>
            </div>
          </ng-container>
        </div>
        <!-- member details end -->
      </div>
      <!-- Boq-end -->


      <!-- MI-survey -->
      <div class="physical-survey-form border my-4" *ngIf="physicalSurveyDetailsArray.length > 0">
        <div class="mt-2 form-name">
          <h5> {{'MI_PHYSICAL_SURVEY/VERIFICATION' | translate}} </h5>
        </div>
        <div class="consent-form my-3" *ngFor="let physicalSurveyDetails of physicalSurveyDetailsArray">
          <ng-container>
            <div class="print border bold" style="margin-top: -0.5px">
              {{'MI_SURVEY_DETAILS' | translate}}
            </div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'TOTAL_COST_OF_VERIFICATION' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.TotalCostVerification }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'FARMER_SHARE_AMOUNT' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.FarmerShare }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TRANSPORT_OTHER_CHARGES' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.BilledTransportAmount }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'MI_AREA_IN_ACRE' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.MIArea }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOTAL_COST' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.TotalCostVerification }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'CHALLAN_TYPE' | translate}}</p>
                    <p>
                      {{ physicalSurveyDetails?.ChallanType }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                    <p> {{ physicalSurveyDetails?.PlantSpacing }} </p>
                  </td>
                  <td>
                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                    <p> {{ physicalSurveyDetails?.RowSpacing }} </p>
                  </td>
                  <td>
                    <p class="bold">{{'MAX_SUBSIDY' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.ProData_MaxSubsidy }}</p>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <p class="bold">{{'LAND_DETAILS' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.LandDetail }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'JE_NAME' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.JEName }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'XEN_NAME' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.XENName }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'JE_REMARKS' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.JERemarks }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'XEN_REMARKS' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.XENRemarks }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'SURVEY_TYPE_(XEN)' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.SurveyType == 0 ? "From Office": "From Field" }}</p>
                  </td>
                </tr>

              </table>
            </div>
          </ng-container>

          <!-- Component details -->
          <ng-container *ngIf="
          physicalSurveyDetails?.listDataForPhysicalVer &&
          physicalSurveyDetails?.listDataForPhysicalVer.length > 0
            ">
            <div class="print border bold">{{'MI_SURVEY_COMPONENT_DETAIL' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <th>{{'CAT_ID' | translate}}</th>
                  <th>{{'CAT_NAME' | translate}}</th>
                  <th>{{'COMPONENT_ID' | translate}}</th>
                  <th>{{'COMPONENT_NAME' | translate}}</th>
                  <th>{{'SIZE_ID' | translate}}</th>
                  <th>{{'SIZE' | translate}}</th>
                  <th>{{'PRICE' | translate}}</th>
                  <th>{{'QUANTITY' | translate}}</th>
                  <th>{{'TOTAL_COST' | translate}}</th>
                  <!-- <th>GST</th> -->
                </tr>
                <tr *ngFor="let item of physicalSurveyDetails?.listDataForPhysicalVer">
                  <td>{{ item.CatId }}</td>
                  <td>{{ item.ProgrammeName }}</td>
                  <td>{{ item.CompId }}</td>
                  <td>{{ item.component }}</td>
                  <td>{{ item.SizeId }}</td>
                  <td>{{ item.size }}</td>
                  <td>{{ item.Price }}</td>
                  <td>{{ item.ActualQuantity }}</td>
                  <td>{{ item.Price*item.ActualQuantity }}</td>
                  <!-- <td>{{item.GST}}</td> -->
                </tr>
              </table>
              <div class="border flex justify-content-end">
                <p class="mx-3">
                  <b>{{'COMPONENT_TOTAL' | translate}}: {{ (physicalSurveyDetails?.TotalCostVerification -
                    physicalSurveyDetails?.BilledTransportAmount) | number: "1.2-2" }} </b>
                </p>
              </div>
            </div>
          </ng-container>
          <!-- Component details end -->

          <!-- List Coordinates and attachments -->
          <ng-container>
            <div class="table">
              <div class="print border bold" *ngIf="physicalSurveyDetails?.listGPSCoordinatesJE.length > 0">
                {{'LIST_GPS_COORDINATES_JE' | translate}}
              </div>
              <div class="table" *ngIf="physicalSurveyDetails?.listGPSCoordinatesJE.length > 0">
                <table class="border">
                  <tr>
                    <th>{{'CORNER_ID' | translate}}</th>
                    <th>{{'LATITUDE' | translate}}</th>
                    <th>{{'LONGITUDE' | translate}}</th>
                  </tr>
                  <tr *ngFor="let item of physicalSurveyDetails?.listGPSCoordinatesJE">
                    <td>{{item.CornerID}}</td>
                    <td>{{item.Latitude}}</td>
                    <td>{{item.Longitude}}</td>
                  </tr>
                </table>
              </div>
              <div class="p-fluid p-formgrid grid  hidden-print" *ngIf="showMapJE">
                <div class="field col-12 md:col-12">
                  <p-gmap [options]="physicalSurveyDetails.optionsJE" type="satellite"
                    [overlays]="physicalSurveyDetails.overlaysJE" [style]="{'width':'100%','height':'320px'}"></p-gmap>
                </div>
              </div>
              <div class="print border bold" *ngIf="physicalSurveyDetails.listImagePathJE.length > 0">
                {{'LIST_IMAGE_PATH_JE' | translate}}
              </div>
              <div class="table" *ngIf="physicalSurveyDetails.listImagePathJE.length > 0">
                <table class="border">
                  <tr>
                    <th>{{'IMAGE_PATH' | translate}}</th>
                    <th>{{'DOCUMENT_TYPE' | translate}}</th>
                  </tr>
                  <tr *ngFor="let item of physicalSurveyDetails.listImagePathJE">
                    <td><a style="cursor: pointer" [href]="item.ImagePath" target="_blank">{{'VIEW_IMAGE' |
                        translate}}</a></td>
                    <td>{{item.DocumentType}}</td>
                  </tr>
                </table>
              </div>

              <div class="print border bold" *ngIf="physicalSurveyDetails?.listGPSCoordinatesXEN.length > 0">
                {{'LIST_GPS_COORDINATES_XEN' | translate}}
              </div>
              <div class="table" *ngIf="physicalSurveyDetails?.listGPSCoordinatesXEN.length > 0">
                <table class="border">
                  <tr>
                    <th>{{'CORNER_ID' | translate}}</th>
                    <th>{{'LATITUDE' | translate}}</th>
                    <th>{{'LONGITUDE' | translate}}</th>
                  </tr>
                  <tr *ngFor="let item of physicalSurveyDetails?.listGPSCoordinatesXEN">
                    <td>{{item.CornerID}}</td>
                    <td>{{item.Latitude}}</td>
                    <td>{{item.Longitude}}</td>
                  </tr>
                </table>
              </div>
              <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapXEN">
                <div class="field col-12 md:col-12">
                  <p-gmap [options]="physicalSurveyDetails.optionsXEN" type="satellite"
                    [overlays]="physicalSurveyDetails.overlaysXEN" [style]="{'width':'100%','height':'320px'}"></p-gmap>
                </div>
              </div>
              <div class="print border bold" *ngIf="physicalSurveyDetails.listImagePathXEN.length > 0">
                {{'LIST_IMAGE_PATH_XEN' | translate}}
              </div>
              <div class="table" *ngIf="physicalSurveyDetails.listImagePathXEN.length > 0">
                <table class="border">
                  <tr>
                    <th>{{'IMAGE_PATH' | translate}}</th>
                    <th>{{'DOCUMENT_TYPE' | translate}}</th>
                  </tr>
                  <tr *ngFor="let item of physicalSurveyDetails.listImagePathXEN">
                    <td><a style="cursor: pointer" [href]="item.ImagePath" target="_blank">{{'VIEW_IMAGE' |
                        translate}}</a></td>
                    <td>{{item.DocumentType}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </ng-container>
          <!-- List Coordinates and attachments end -->

          <!-- Calculated Subsidy details -->
          <ng-container *ngIf="physicalSurveyDetails?.calculatedSubsidyDataForMIPhys">
            <div class="print border bold">{{'MI_CALCULATED_SUBSIDY_DETAIL' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.calculatedSubsidyDataForMIPhys?.StateShareAmount }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.calculatedSubsidyDataForMIPhys?.CenterShareAmount }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'SUBSIDY_TO_FARMER_AMOUNT' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.calculatedSubsidyDataForMIPhys?.SubsidyToFarmerAmount }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'SUBSIDY_TO_VENDOR_AMOUNT' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.calculatedSubsidyDataForMIPhys?.SubsidyToVendorAmount }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'FARMER_REFUND_AMOUNT' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.calculatedSubsidyDataForMIPhys?.FarmerRefundAmount }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>
          <!-- Calculated Subsidy details End -->
        </div>

      </div>
      <!-- MI-survey-end  -->

      <!-- Pond Tank Stage-1 -->
      <div class="tank-stage1-form border my-4" *ngIf="PondVerData">
        <div class="mt-2 form-name">
          <h5> {{'TANK_STAGE1' | translate}} </h5>
        </div>
        <div class="consent-form my-3">
          <ng-container>
            <div class="print border bold " style="margin-top:-0.5px;">{{'TANK_STAGE1_DETAILS' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'TOP_LENGTH' | translate}}</p>
                    <p>{{PondVerData?.topLength}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOP_BREADTH' | translate}}</p>
                    <p>{{PondVerData?.topBreadth}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'BOTTOM_LENGTH' | translate}}</p>
                    <p>{{PondVerData?.bottomLength}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'BOTTOM_BREADTH' | translate}}</p>
                    <p>{{PondVerData?.bottomBreadth}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'DEPTH' | translate}}</p>
                    <p>{{PondVerData?.depth}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'LATITUDE' | translate}}</p>
                    <p>{{PondVerData?.depth}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'LONGITUDE' | translate}}</p>
                    <p>{{PondVerData?.depth}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'VOLUME_OF_EARTHWORK_CUM/CFT' | translate}}</p>
                    <p>{{PondVerData?.tankLat}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOTAL_COST_OF_EARTH_WORK_AS_PER_MB_OF_JE' | translate}}</p>
                    <p>{{PondVerData?.tankLng}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'AMOUNT_OF_SUBSIDY_OF_EARTH_WORK' | translate}}</p>
                    <p>{{PondVerData?.VolumeEarthWork}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'UPLOADED_COPY' | translate}}</p>
                    <p><a href="{{PondVerData?.estimateCopy}}" target="_blank">{{'VIEW' | translate}}</a></p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>

          <!-- <div class="card" *ngIf="prev" style=" background-color: rgb(201,209,209);"> -->
          <div class="print border bold">{{'TANK_STAGE1_ATTACHMENT_DETAILS' | translate}}</div>
          <div class="p-fluid p-formgrid grid" style="padding:10px">
            <div *ngFor="let image of PondVerData?.listImagePath; let index = index;" class="field m-3" key="index">
              <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index)" style="max-width: 300px; max-height: 300px;" />
              <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <!-- </div> -->


        </div>
      </div>
      <!-- Tank Stage-1-end -->

      <!-- Tank Stage-2 -->
      <div class="tank-stage1-form border my-4" *ngIf="PondVerDataStage2">
        <div class="mt-2 form-name">
          <h5> {{'TANK_STAGE2' | translate}} </h5>
        </div>
        <div class="consent-form my-3">
          <ng-container>
            <div class="print border bold " style="margin-top:-0.5px;">{{'TANK_STAGE2_DETAILS' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'TOP_LENGTH' | translate}}</p>
                    <p>{{PondVerDataStage2?.topLength}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOP_BREADTH' | translate}}</p>
                    <p>{{PondVerDataStage2?.topBreadth}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'BOTTOM_LENGTH' | translate}}</p>
                    <p>{{PondVerDataStage2?.bottomLength}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'BOTTOM_BREADTH' | translate}}</p>
                    <p>{{PondVerDataStage2?.bottomBreadth}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'DEPTH' | translate}}</p>
                    <p>{{PondVerDataStage2?.depth}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOTAL_COST_OF_WATER_TANK' | translate}}</p>
                    <p>{{PondVerDataStage2?.TotalEstimatedCost}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'TOTAL_AMOUNT_OF_SUBSIDY' | translate}}</p>
                    <p>{{PondVerDataStage2?.TotalEstimatedSubsidy}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'AMOUNT_OF_TOTAL_SUBSIDY' | translate}}</p>
                    <p>{{PondVerDataStage2?.ActualSubsidy_Stage2}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'ASSISTANCE_PAID_AR_STAGE1' | translate}}
                    </p>
                    <p>{{PondVerDataStage2?.AssistancePaidAtStage1}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'UPLOADED_COPY' | translate}}</p>
                    <p><a href="{{PondVerDataStage2?.estimateCopy_Stage1}}" target="_blank">{{'VIEW' | translate}}</a>
                    </p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>
          <div class="print border bold">{{'TANK_STAGE2_ATTACHMENT_DETAILS' | translate}}</div>
          <div class="p-fluid p-formgrid grid" style="padding:10px">
            <div *ngFor="let image of PondVerDataStage2?.listImagePath; let index = index;" class="field m-3"
              key="index">
              <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index)" style="max-width: 300px; max-height: 300px;" />
              <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
      <!-- Tank Stage-2-end -->
    </div>
    <!-- <app-vendor-mi-estimation-consent-form></app-vendor-mi-estimation-consent-form> -->

    <div class="flex justify-content-around mb-2">
      <button pButton pRipple icon="pi pi-print" type="submit" label="{{'PRINT' | translate}}"
        (click)="onPrint('printableArea')"></button>
    </div>


    <!-- <div class="card" reflow="true" *ngIf="!farmerData2"> -->
    <div class="card" reflow="true">
      <div *ngIf="viewWorkFlowAllStatus">
        <app-work-flow-all-status></app-work-flow-all-status>
      </div>

      <button *ngIf="!viewWorkFlowAllStatus" pButton type="button" label="{{'VIEW_APPLICATION_STATUS' | translate}}"
        class="p-button-secondary" (click)="workFlowAllStatus()"></button>
    </div>
  </div>

  <p-dialog [(visible)]="displayFileDialog" [modal]="true" [style]="{ margin: '3rem' }" [maximizable]="true"
    [draggable]="false" [resizable]="true" (onHide)="onCloseDialog()">
    <ng-template pTemplate="header">
      <div>
        <button pButton pRipple icon="pi pi-search-plus" class="p-button-text" (click)="transformImage(null, 'zoom-in')"
          [disabled]="numberEquals(scalingAmount, 1)"></button><br />
        <button pButton pRipple icon="pi pi-search-minus" class="p-button-text"
          (click)="transformImage(null, 'zoom-out')" [disabled]="numberEquals(scalingAmount, '0.1')"></button>
      </div>
    </ng-template>
    <!-- <div class="flex flex-wrap align-items-center justify-content-center">
      <img [src]="rotatableFilePath" id="myname" #myname
        style="object-fit: contain; z-index: 0; max-width: 700px; max-height: 700px; aspect-ratio: 1;">
    </div> -->
    <embed [src]="getSafeUrl()" style="width: 100%; height: 100%" id="myname" #myname />

    <ng-template pTemplate="footer">
      <div class="flex flex-wrap align-items-center justify-content-center">
        <button pButton pRipple label="{{'ROTATE_LEFT' | translate}}" icon="pi pi-angle-left" class="p-button-success"
          (click)="transformImage('left', null)"></button>
        <button pButton pRipple label="{{'ROTATE_RIGHT' | translate}}" icon="pi pi-angle-right" class="p-button-success"
          (click)="transformImage('right', null)"></button>
      </div>
    </ng-template>
  </p-dialog>
</div>
<div *ngIf="!applicationDetails?.APP_ID">
  <div class="card" reflow="true">{{'APPLICATION_NOT_FOUND' | translate}}</div>
</div>